import { render, staticRenderFns } from "./DownloadHero.vue?vue&type=template&id=7f444b0e&scoped=true"
import script from "./DownloadHero.vue?vue&type=script&lang=js"
export * from "./DownloadHero.vue?vue&type=script&lang=js"
import style0 from "./DownloadHero.vue?vue&type=style&index=0&id=7f444b0e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f444b0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
